/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description React Hook useUploadAttachments
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

interface DeleteAttachmentProps {
	entityType: EntityTypeEnum;
	entityId: string;
	blobId: string;
}

const useDeleteAttachment = (): UseMutationResult<unknown, IAxiosError, DeleteAttachmentProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ entityType, entityId, blobId }) => {
			const { data } = await api.AttachmentApi.deleteEntityAttachment({
				entityType,
				entityId,
				blobId,
			});
			return data;
		},
		onSuccess: (_, { entityType, entityId }) => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.allAttachments, { id: entityId, entityType }] });
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useDeleteAttachment;
